// Builds the challenges INSERT payload for duplication. purchase_reference is
// deliberately excluded: the invariant is one live cohort per reference, so the
// caller writes it in a second step: always onto the NEW row, and it clears the
// source only for course-type challenges (courseIdResolver looks a course up with
// .maybeSingle(), which throws on a second row). Weekly entry/community cohorts keep
// the reference on every cohort, so a new one is born tagged and nothing is ever
// "in transit" to lose. That means duplicates are expected — migration
// 20260510130100 (partial UNIQUE on purchase_reference) is neutralized on purpose.
export interface DuplicateSourceConfig {
  pace_mode: string | null;
  pace_days: number[] | null;
  anchor_day: number | null;
  grace_period_days: number | null;
  // Optional so Task 1's existing callers/tests stay type-valid. Loose `!= null`
  // checks below cover both null and undefined, so an omitted field falls back
  // to the column default ('main' / false).
  entry_line?: string | null;
  paid_entry?: boolean | null;
  purchase_reference?: string | null;
}

export function buildDuplicatePayload(
  config: DuplicateSourceConfig,
  newData: { title: string; startDate: string; endDate: string; totalDays: number },
  base: { description: string; challengeType: string; coverImage: string | null; preparationDays: number | null }
): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    title: newData.title,
    description: base.description,
    challenge_type: base.challengeType,
    start_date: newData.startDate,
    end_date: newData.endDate,
    total_days: newData.totalDays,
    cover_image: base.coverImage,
    preparation_days: base.preparationDays || 0,
    status: "upcoming" as const,
  };
  if (config.pace_mode !== null) payload.pace_mode = config.pace_mode;
  if (config.pace_days !== null) payload.pace_days = config.pace_days;
  if (config.anchor_day !== null) payload.anchor_day = config.anchor_day;
  if (config.grace_period_days !== null) payload.grace_period_days = config.grace_period_days;
  if (config.entry_line != null) payload.entry_line = config.entry_line;
  if (config.paid_entry != null) payload.paid_entry = config.paid_entry;
  return payload;
}
